module.exports = __webpack_public_path__ + "img/success.d4e70e1c.svg";